function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "tofu",
  transform: "translate(1154 232.232)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_70",
  "data-name": "Group 70",
  transform: "translate(-1218 -232.232)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_69",
  "data-name": "Group 69",
  transform: "translate(64)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_138",
  "data-name": "Path 138",
  d: "M344.169,112.067V32.02A32.055,32.055,0,0,0,312.15,0H104.024A32.056,32.056,0,0,0,72.005,32.02v80.049a8,8,0,0,0-8.005,8V264.159a8,8,0,0,0,8.005,8.005v80.049a32.056,32.056,0,0,0,32.02,32.02H312.15a32.056,32.056,0,0,0,32.02-32.02V272.165a8,8,0,0,0,8.005-8.005V120.072A8,8,0,0,0,344.169,112.067ZM280.13,32.02a24.014,24.014,0,1,1-24.014,24.014A24.041,24.041,0,0,1,280.13,32.02Zm24.014,56.033a8.005,8.005,0,1,1-8.005-8.005A8.005,8.005,0,0,1,304.145,88.053ZM232.1,64.038a8.005,8.005,0,1,1-8.005,8.005A8,8,0,0,1,232.1,64.038ZM136.043,336.2a24.014,24.014,0,1,1,24.014-24.014A24.041,24.041,0,0,1,136.043,336.2Zm32.02,16.009a8.005,8.005,0,1,1,8.005-8.005A8.005,8.005,0,0,1,168.063,352.212Zm168.1-96.058H80.009V128.078H336.164V256.154Z",
  transform: "translate(-64)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_139",
  "data-name": "Path 139",
  d: "M181.333,269.367a24.014,24.014,0,0,0,48.029,0v-32.02a24.014,24.014,0,0,0-48.029,0Zm16.01-32.02a8,8,0,1,1,16.009,0v32.02a8.005,8.005,0,1,1-16.01,0v-32.02Z",
  transform: "translate(-93.28 -53.237)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_140",
  "data-name": "Path 140",
  d: "M274.671,293.381a8,8,0,0,0,8.005-8.005V261.362h16.009a8.005,8.005,0,1,0,0-16.01H282.676V229.342h24.014a8.005,8.005,0,0,0,0-16.01h-32.02a8,8,0,0,0-8.005,8.005v64.038A8,8,0,0,0,274.671,293.381Z",
  transform: "translate(-114.575 -53.236)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M365.347,293.382a24.041,24.041,0,0,0,24.014-24.014V221.338a8,8,0,1,0-16.009,0v48.029a8.005,8.005,0,1,1-16.01,0V221.338a8.005,8.005,0,1,0-16.01,0v48.029A24.042,24.042,0,0,0,365.347,293.382Z",
  transform: "translate(-133.207 -53.237)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M104.005,229.343h16.009v56.034a8.005,8.005,0,1,0,16.01,0V229.343h16.009a8.005,8.005,0,0,0,0-16.01H104.005a8.005,8.005,0,1,0,0,16.01Z",
  transform: "translate(-71.986 -53.237)",
  fill: "#65ccb8"
}))));

function SvgTofu1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 288.175,
    height: 384.233,
    viewBox: "0 0 288.175 384.233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTofu1);
export default __webpack_public_path__ + "static/media/tofu-1.5cbafe84.svg";
export { ForwardRef as ReactComponent };